import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityMap, Product } from '../../../../core/model';
import { CatalogSearchService } from '../../../../features/catalog/container/catalog/catalog-search.service';
import { BadgeType } from '../../badge';

@Component({
  selector: 'py-campaign-items',
  templateUrl: './campaign-items.component.html',
})
export class CampaignItemsComponent {
  readonly campaignBadgeType = BadgeType.Campaign;

  extraSmallProductsList: Array<Observable<Product>>;

  constructor(private catalogSearchService: CatalogSearchService) {}

  @Input() loadingProducts: boolean;
  @Input() infiniteScrollDisabled: boolean;
  @Input() currentPage: number;
  @Input() queryParams: EntityMap<string>;

  @Input()
  set products(products: Array<Observable<Product>>) {
    // Here we split the products to different campaign product sizes in the future
    this.extraSmallProductsList = products;
  }

  nextPage($event: number): void {
    this.catalogSearchService.loadMore($event);
  }
}
